import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d80a940"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增课程")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分类：", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"50px"} }, "搜索：", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("推荐")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkable_tag = _resolveComponent("a-checkable-tag")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "课程列表",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.goSet
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, { align: "middle" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_a_checkable_tag, {
                  checked: _ctx.searches.type === '',
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSearch('type', '', $event)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["checked"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category, (item) => {
                  return (_openBlock(), _createBlock(_component_a_checkable_tag, {
                    checked: _ctx.searches.type === item.id,
                    key: item.id,
                    onChange: ($event: any) => (_ctx.onSearch('type', item.id, $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["checked", "onChange"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider, { type: "horizontal" }),
        _createVNode(_component_a_row, { align: "middle" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_a_input_search, {
                    value: _ctx.searches.keywords,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.keywords) = $event)),
                    "enter-button": "",
                    onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearch('keywords', $event, $event))),
                    placeholder: "输入关键字搜索"
                  }, null, 8, ["value"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'title')
          ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(text), 1)
              ]),
              default: _withCtx(() => [
                (record.is_recommend === 1)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "orange",
                      style: {"margin":"0"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(text.length > 25 ? text.substr(0, 25) + '...' : text), 1)
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (column.key === 'thumb')
          ? (_openBlock(), _createBlock(_component_ImageView, {
              key: 1,
              "image-url": text
            }, null, 8, ["image-url"]))
          : _createCommentVNode("", true),
        (column.key === 'lecturer')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (record.tutor == null )
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(record.lecturer), 1))
                : _createCommentVNode("", true),
              (record.lecturer == '' && record.tutor !== null )
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(record.tutor.name), 1))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'type')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.renderType(text)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'recommend')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              (record.recommend == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "不推荐"))
                : _createCommentVNode("", true),
              (record.recommend == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "推荐"))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.goDetail(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.goSet(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_popconfirm, {
                title: "是否删除该课程?",
                onConfirm: ($event: any) => (_ctx.onDel(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ], 64))
}